import { Box, Container, Grid } from 'components/box';
import { CategoryPage } from 'components/_pages/category/types';
import ProductListing from 'components/_shared/widgets/product-listing';
import { css } from '@emotion/react';
import asTitleCase from '../../../../util/as-title-case';
import { File } from 'types/types';
import resourceUrl from '../../../../util/make-url';
import Empty from './empty';
import { categoryIdAsTitleCase } from 'components/_pages/category/utils';

const CategoryBanner = ({
  categoryName,
  banner,
}: {
  categoryName: string;
  banner: File;
}) => {
  const image = resourceUrl(banner.url, {
    isAssetUrl: false,
    quality: 75,
    width: 1200,
  });

  return (
    <Box
      tabIndex={0}
      m={0}
      p={0}
      css={theme => css`
        border-radius: ${theme.radii[3]}px;
        overflow: hidden;
      `}
    >
      <img
        aria-label={`${categoryName} Banner`}
        alt={`${categoryName} Banner`}
        src={image}
        css={css`
          width: 100%;
          margin: 0;
          padding: 0;
        `}
      />
    </Box>
  );
};

const Body = ({ banner, category, categoryId, ...props }: CategoryPage) => (
  <Container py={3}>
    {props.items.length === 0 ? (
      <Empty />
    ) : (
      <Grid>
        {!!banner && (
          <CategoryBanner
            categoryName={
              category
                ? asTitleCase(category.name)
                : categoryIdAsTitleCase(categoryId)
            }
            banner={banner}
          />
        )}
        <ProductListing {...props} />
      </Grid>
    )}
  </Container>
);

export default Body;
